import { mediaLgMinus, mediaMdMinus } from "./breakpoints";

const TYPOGRAPHY = {
  displayLarge: {
    fontFamily: "Roboto",
    fontSize: "57px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "64px",
    letterSpacing: "-0.25px",
  },
  displayMedium: {
    fontFamily: "Roboto",
    fontSize: "45px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "52px",
    letterSpacing: "0px",
  },
  displaySmall: {
    fontFamily: "Roboto",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "44px",
    letterSpacing: "0px",
  },
  headlineLarge: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0px",
    fontSize: "32px",
    lineHeight: "40px",
  },
  headlineMedium: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0px",
    fontSize: "28px",
    lineHeight: "36px",
    [mediaLgMinus]: {
      fontSize: "22px",
      lineHeight: "28px",
    },
    [mediaMdMinus]: {
      fontSize: "16px",
      lineHeight: "24px",
    },
  },
  // Figma's "Static/Headline Medium": the same ramp step without the
  // responsive clamps, for text inside a fixed width box (the login card).
  headlineMediumStatic: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0px",
    fontSize: "28px",
    lineHeight: "36px",
  },
  headlineSmall: {
    fontFamily: "Roboto",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "32px",
    letterSpacing: "0px",
  },

  titleLarge: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0px",
    fontSize: "22px",
    lineHeight: "28px",
  },
  titleMedium: {
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },
  titleSmall: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0.1px",
  },

  labelLarge: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0.1px",
  },
  labelMedium: {
    fontFamily: "Roboto",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },
  labelSmall: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },

  bodyLarge: {
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
  },
  bodyMedium: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
  bodyMedium2: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "21px",
    letterSpacing: "0.131px",
  },
  bodySmall: {
    fontFamily: "Roboto",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: "0.4px",
  },
  bodyXSmall: {
    fontFamily: "Roboto",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "14px",
    letterSpacing: "0.4px",
  },
};

export default TYPOGRAPHY;
